import { propTypes, withFormsy } from 'formsy-react';
import React from 'react';
import { DefaultCheckbox } from 'twyne-new.ui'

class Checkbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: true,
    };
  }

  changeValue = checked => {
    this.props.setValue(checked);
    this.setState({ value: checked });
  }

  render () {
    const { disabled } = this.props
    // const isInvalidClass = !isValid() && !isPristine() ? 'is-invalid' : ''
    const value = this.props.getValue();

    return <>
      <DefaultCheckbox
        id={this.props.name}
        onChange={this.changeValue}
        disabled={disabled}
        value={value}
      >
        {this.props.title}
      </DefaultCheckbox>
    </>
  }
}

Checkbox.propTypes = {
  ...propTypes
};

export default withFormsy(Checkbox);
